module.exports = __webpack_public_path__ + "static/media/b2_author.0532d9ea.mp3";